import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
	ICreateCartPayload,
	IProfessionalCart,
} from 'app/interfaces/checkout.interface';
import {
	PaymentPageOptions,
	PaymentPageResponse,
} from 'app/interfaces/ebanx.interface';
import { environment } from 'environments/environment';

@Injectable({
	providedIn: 'root',
})
export class CheckoutService {
	url = environment.servicesUrl;

	constructor(private http: HttpClient) {}

	public ebanxPaymentPage(options: PaymentPageOptions) {
		return this.http.post<PaymentPageResponse>(environment.checkout.url, {
			...options,
			returnUrl: environment.checkout.returnUrl,
		});
	}

	public createCart(cart: ICreateCartPayload) {
		return this.http.put<IProfessionalCart>(
			`${this.url}/checkout/professional/cart`,
			cart
		);
	}

	public getCart(id: IProfessionalCart['id']) {
		return this.http.get<IProfessionalCart>(
			`${this.url}/checkout/professional/cart/${id}`
		);
	}

	public updateCart(cart: IProfessionalCart) {
		return this.http.post<IProfessionalCart>(
			`${this.url}/checkout/professional/cart/${cart.id}`,
			cart
		);
	}

	public finalizeCart(cart: IProfessionalCart) {
		return this.http.post<IProfessionalCart>(
			`${this.url}/checkout/professional/cart/${cart.id}/finalize`,
			cart
		);
	}
}
